import { render } from "./Wrapper.vue?vue&type=template&id=920f904a"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__